import React from 'react';

import * as Atoms from '../../Atoms';
import * as Molecules from '../../Molecules';
import * as T from './interfaces';
import {
  Container,
  LabelRestaurant,
  Triangle,
  ContainerSearch,
} from './styles';
import searchIcon from 'assets/images/icons/search-icon.svg';

export const BackButtonHeader: React.FC<T.IBackButtonHeader> = ({
  id,
  isTitle,
  isBackgroundColor,
  showIconSearch,
  hideDesktop,
  hideBanner,
  handleClickSearchButtonMobile,
  storeSelected,
  ...rest
}) => {
  return (
    <Container
      {...rest}
      data-testid={`backButtonHeader@${id}`}
      isBackgroundColor={isBackgroundColor}
      hideDesktop={hideDesktop}
      hideAllDevices={!storeSelected?.name}
      hideBanner={hideBanner}
    >
      <Atoms.BackButton
        isSuccess
        colorBackButton={isBackgroundColor === 'orange' ? 'white' : 'orange'}
      />
      <LabelRestaurant isTitle={isTitle} isBackgroundColor={isBackgroundColor}>
        {storeSelected?.name && <span>{storeSelected.name}</span>}
        <Triangle isBackgroundColor={isBackgroundColor} />
      </LabelRestaurant>
      {showIconSearch && (
        <ContainerSearch onClick={handleClickSearchButtonMobile}>
          <img src={searchIcon} alt="Buscar" />
        </ContainerSearch>
      )}
    </Container>
  );
};
